module.exports = __webpack_public_path__ + "img/stock1.28754614.png";